const application = {
  weight: ['g', 'kg', 'mt'],
  voulme: ['m3', 'ft3', 'cm3', 'gal'],
};

const movementType = {
  SECONDARY: 1,
  PRIMARY: 2,
  INWARD: 3,
  RETURNS: 4,
};

const movementTypeForConfig = {
  SECONDARY: 1,
  PRIMARY: 2,
  VENDOR: 3,
  RETURNS: 4,
};

const InvertedMovements = {
  1: 'secondary',
  2: 'primary',
  3: 'vendor',
  4: 'return',
};

const movementMap = {
  1: 'SECONDARY',
  2: 'PRIMARY',
  3: 'INWARD',
  4: 'RETURN',
};

// used in Frontend, Don't remove
// used pre-populate truck-out in material invoice
const movementMapLower = {
  1: 'secondary',
  2: 'primary',
  3: 'inward',
  4: 'return',
};

const movementMapLowerForConfig = {
  1: 'secondary',
  2: 'primary',
  3: 'vendor',
  4: 'return',
};

const movementText = {
  SECONDARY: 'Secondary',
  PRIMARY: 'Primary',
  INWARD: 'Inward',
  RETURN: 'Return',
};

const settingsMovement = {
  SECONDARY: 'Secondary',
  PRIMARY: 'Primary',
  VENDOR: 'Vendor',
  RETURN: 'Return',
};

const settingsMovementMap = {
  1: 'Secondary',
  2: 'Primary',
  3: 'Vendor',
  4: 'Return',
};
const settingsBillToPartyMap = {
  1: 'Source',
  2: 'Destination',
  3: 'central ho',
};

const MasterMovement = {
  SECONDARY: 1,
  PRIMARY: 2,
  VENDOR: 3,
  RETURN: 4,
};

const optimaMovementString = {
  SECONDARY: 'SECONDARY',
  PRIMARY: 'PRIMARY',
  INWARD: 'INWARD',
  RETURN: 'RETURN',
};

const movementTypeMap = [
  { id: 1, name: 'Secondary' },
  { id: 2, name: 'Primary' },
  { id: 3, name: 'Vendor' },
  { id: 4, name: 'Return' },
];

const queryConstants = { batchLimit: 1000 };

const getOrderSubTypesText = () => ({
  OUTBOUND_STANDARD: 'Standard',
  INBOUND_VENDOR: 'Vendor',
  INBOUND_RETURN: 'Return',
});

const emailNotificationLimit = () => ({
  limit: 10,
});

const getOrderSubTypes = () => ({
  OUTBOUND_STANDARD: 1,
  INBOUND_VENDOR: 2,
  INBOUND_RETURN: 3,
});

const getDepotTypes = () => ({
  STANDARD: 1,
  VENDOR: 2,
  RETURN: 3,
});
const uploadStatus = {
  CREATED: 'CREATED',
  PROGRESS: 'PROGRESS',
  COMPLETED: 'COMPLETED',
  UPLOAD_FAILED: 'FAILED',
};
const reportMessage = {
  NO_DATA_TO_EXPORT: 'No data to export',
  SUCCESS_MSG: 'Successful. Report will be sent to ',
};

const getDefaultOrderSubType = () => getOrderSubTypes().OUTBOUND_STANDARD;

const getDefaultDepotType = () => getDepotTypes().STANDARD;

const roles = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  DEPOT_MANAGER: 'depot_manager',
  GATE_MANAGER: 'gate_manager',
  DOCK_MANAGER: 'dock_manager',
  LIBRARIAN: 'librarian',
  ACCOUNTANT: 'accountant',
  CHECKER: 'checker',
  SYSTEM: 'system',
  VENDOR_GATE_MANAGER: 'vendor_gate_manager',
};

const INDENT_SOURCE = {
  REGULAR: 1,
  OPTIMA: 2,
  BULK: 3,
  INTEGRATION: 4,
  OPTIMA_FOR_PTL: 5,
  DIRECT_DISPATCH: 6,
  OPTIMA_DIRECT_DISPATCH: 7,
  EXIM: 8,
  OPTIMA_MULTILEG: 9,
  ERP: 10,
};

const IndentSourceGroupingforSob = {
  MANUAL: ['REGULAR', 'BULK'],
  OPTIMA: ['OPTIMA', 'OPTIMA_FOR_PTL', 'OPTIMA_MULTILEG'],
  INTEGRATION: ['ERP', 'INTEGRATION'],
  // direct dispatch and exim are ignored for SOB.
};

const IndentPrefix = {
  1: 'M',
  2: 'O', // OPTIMA
  3: 'M',
  4: 'M',
  5: 'O', // OPTIMA_FOR_PTL
  6: 'D', // DIRECT_DISPATCH
  7: 'OD', // OPTIMA_DIRECT_DISPATCH
  9: 'OM', // OPTIMA MULTILEG
  10: 'E', // ERP
};

const RequestPrefix = {
  SHIPMENT_NUMBER: 'SN',
  REQUEST_ID: 'RQ'
}

const RequestStatus = {
  CREATED: 1,
  INDENTED: 2,
  REJECTED: 3
}

const IndentSource = {
  OPTIMA: 'Optima',
  MANUAL: 'Manual',
};

const userStatus = {
  ACTIVE: 1,
  INACTIVE: 0,
};

const status = {
  ACTIVE: 1,
  INACTIVE: 2,
};

const depotStatus = {
  ACTIVE: 1,
  INACTIVE: 2,
};

const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/;

const environmentDomainMapping = () => ({
  staging: 'pandostaging.in',
  demo: 'gopando.in',
  production: 'pando.in',
  development: 'pandostaging.in',
});

const courierServiceAction = () => ({
  CREATE: 1,
  MATERIAL_UPDATE: 2,
  PICKUP_RESCHEDULE: 3,
  CANCEL: 4,
  TRACK: 5,
  FETCH_LR: 6,
  CLOSE_MANIFEST: 7,
  RATE: 8,
  MANUAL_UPLOAD: 9,
  RFQ: 10,
  EWAY_BILL: 11,
});

const courierBookingRules = {
  AFTER_MATERIAL_INVOICE: 'AFTER_MATERIAL_INVOICE',
  AFTER_LR_MATERIAL_INVOICE : 'AFTER_LR_MATERIAL_INVOICE'
};

const getVehicleTypes = () => ({
  FTL: 'FTL',
  PTL: 'PTL',
});


const defaultMovementMapping = () => ({
  DEPOT_TO_DEPOT: movementType.PRIMARY,
  DEPOT_TO_CONSIGNEE: movementType.SECONDARY,
  DEPOT_TO_PORT: movementType.SECONDARY,
  DEPOT_TO_VENDOR_DEPOT: movementType.SECONDARY,
  CONSIGNEE_TO_DEPOT: movementType.RETURNS,
  CONSIGNEE_TO_VENDOR_DEPOT: movementType.RETURNS,
  VENDOR_DEPOT_TO_DEPOT: movementType.INWARD,
  PORT_TO_DEPOT: movementType.INWARD,
  DEPOT_TO_NO_MASTER_ENTITY: movementType.SECONDARY,
});

const inBoundAndOutBoundMapping = () => ({
  INBOUND: [movementType.PRIMARY, movementType.INWARD, movementType.RETURNS],
  OUTBOUND: [movementType.PRIMARY, movementType.SECONDARY],
});
const orderDestinationType = {
  DEPOT: 1,
  CONSIGNEE: 2,
  VENDOR_DEPOT: 3,
  PORT: 4,
  NO_MASTER_ENTITY: 5,
};

const defaultDestinationPriorityType = () => ([
  { source: 'DEPOT', destinationType: 1, priority: 1 },
  { source: 'CONSIGNEE', destinationType: 2, priority: 2 },
  { source: 'VENDOR_DEPOT', destinationType: 3, priority: 3 },
  { source: 'NO_MASTER_ENTITY', destinationType: 5, priority: 5 },
  { source: 'PORT', destinationType: 4, priority: 4 },
]);

const defaultSourcePriorityType = () => ([
  { source: 'DEPOT', sourceType: 1, priority: 1 },
  { source: 'CONSIGNEE', sourceType: 2, priority: 2 },
  { source: 'VENDOR_DEPOT', sourceType: 3, priority: 3 },
  { source: 'PORT', sourceType: 4, priority: 4 },
]);

const getContentTypeString = () => 'Content-type';
const getExcelContentType = () => 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const userPasswordExpiry = 24 * 60 * 60 * 1000;

const defaultPageLimit = 25;
const OrderPageLimit = 13;
const xlsxExtensions = ['.xlsx', '.xlsm', '.xltx', '.xltm', '.xls', '.csv'];

const getDelayedProcessType = () => ({
  PAYMENT_DELAYED_FOR_DEDICATED_TRUCK: 'PAYMENT_DELAYED_FOR_DEDICATED_TRUCK',
  PAYMENT_DELAYED_FOR_ROUND_TRIP_PARENT: 'PAYMENT_DELAYED_FOR_ROUND_TRIP_PARENT',
});

const getDelayedProcessTriggerType = () => ({
  EVENT_BASED_TRIGGER: 'EVENT_BASED_TRIGGER',
  TIME_BASED_TRIGGER: 'TIME_BASED_TRIGGER',
});
const mapType = () => ({
  HERE_MAP: 'HEREMAP',
  GMAP: 'GMAP',
});

const purchaseOrderInterface = () => ({
  SFTP: 1,
  API: 2,
});

const maxEmailUserLimit = 50;

const getUserNotificationType = () => ({
  BOTH: 'BOTH',
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND',
});
const purchaseOrderTypeInLr = {
  DEFAULT: 1,
  MATERIAL_LEVEL: 2,
};

const movementLower = {
  SECONDARY: 'secondary',
  PRIMARY: 'primary',
  VENDOR: 'vendor',
  RETURN: 'return',
};

const freightTypeList = {
  INDENT_EX_WORKS: 0,
  INDENT_PARTY_COLLECT: 1,
};

const freightTypeTextMapping = {};
freightTypeTextMapping[freightTypeList.INDENT_EX_WORKS] = 'EX WORKS';
freightTypeTextMapping[freightTypeList.INDENT_PARTY_COLLECT] = 'PARTY COLLECT';


const epodByConfig = {
  INDENT_NUMBER: 'indent_number',
  SHIPMENT_NO: 'shipment_number',
};

const sourceOrDestinationType = {
  GATE: 'GATE',
  CONSIGNEE: 'CONSIGNEE',
};

const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// ----> TO DO
// ApplicationConstants import from pando-common-lib

module.exports = {
  mapType,
  application,
  movementType,
  InvertedMovements,
  movementText,
  roles,
  INDENT_SOURCE,
  IndentPrefix,
  IndentSource,
  userStatus,
  depotStatus,
  passwordPattern,
  getDepotTypes,
  environmentDomainMapping,
  getOrderSubTypes,
  getDefaultDepotType,
  getDefaultOrderSubType,
  reportMessage,
  queryConstants,
  courierServiceAction,
  defaultPageLimit,
  movementMap,
  movementMapLower,
  movementTypeMap,
  getOrderSubTypesText,
  emailNotificationLimit,
  getVehicleTypes,
  defaultMovementMapping,
  inBoundAndOutBoundMapping,
  defaultSourcePriorityType,
  defaultDestinationPriorityType,
  uploadStatus,
  getContentTypeString,
  getExcelContentType,
  xlsxExtensions,
  status,
  userPasswordExpiry,
  getDelayedProcessType,
  getDelayedProcessTriggerType,
  optimaMovementString,
  purchaseOrderInterface,
  maxEmailUserLimit,
  movementMapLowerForConfig,
  settingsMovement,
  settingsMovementMap,
  settingsBillToPartyMap,
  MasterMovement,
  orderDestinationType,
  getUserNotificationType,
  freightTypeList,
  purchaseOrderTypeInLr,
  movementLower,
  epodByConfig,
  courierBookingRules,
  weekDays,
  IndentSourceGroupingforSob,
  freightTypeTextMapping,
  sourceOrDestinationType,
  movementTypeForConfig,
  RequestPrefix,
  RequestStatus,
  OrderPageLimit,
};
